import React from 'react';

const IntegrationDepartmentId: React.FC = () => {
  const path = window.location.pathname;
  return (
    <div>{path.slice(path.indexOf('department/') + 'department/'.length)}</div>
  );
};

export default IntegrationDepartmentId;
